/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ServiceArgs } from "@reservauto/react-shared/services/AuthenticatedServiceBase";
import FrontOfficeServiceBase from "../../shared/FrontOfficeServiceBase";
import { FetchPromise } from "@reservauto/react-shared/services/ServiceBase";
import * as dto from "./dto";

export interface BranchAvailableBranchSettingsService_GetAvailableSetting<T> extends ServiceArgs<T> {
    branchId: number;
}

export class BranchAvailableBranchSettingsService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Branch/";

    /**
     * @return OK
     */
    public getAvailableSetting<T>(params: BranchAvailableBranchSettingsService_GetAvailableSetting<T>): FetchPromise<dto.BranchAvailableSettingListDTO> {
       return this.authorizedGet({
            pathParams: {
                "branchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{branchId}/AvailableSetting",
        });
    }
}

export interface BranchAvailableCitiesService_GetAvailableCity<T> extends ServiceArgs<T> {
    branchId: number;
}

export class BranchAvailableCitiesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Branch/";

    /**
     * @return OK
     */
    public getAvailableCity<T>(params: BranchAvailableCitiesService_GetAvailableCity<T>): FetchPromise<dto.BranchAvailableCityListDTO> {
       return this.authorizedGet({
            pathParams: {
                "branchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{branchId}/AvailableCity",
        });
    }
}

export interface BranchAvailableLanguagesService_GetAvailableLanguage<T> extends ServiceArgs<T> {
    branchId: number;
}

export class BranchAvailableLanguagesService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Branch/";

    /**
     * @return OK
     */
    public getAvailableLanguage<T>(params: BranchAvailableLanguagesService_GetAvailableLanguage<T>): FetchPromise<dto.BranchAvailableLanguageListDTO> {
       return this.authorizedGet({
            pathParams: {
                "branchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{branchId}/AvailableLanguage",
        });
    }
}

export interface BranchGroupedAvailableInfoService_GetGroupedAvailableInfo<T> extends ServiceArgs<T> {
    branchId: number;
}

export class BranchGroupedAvailableInfoService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Branch/";

    /**
     * @return OK
     */
    public getGroupedAvailableInfo<T>(params: BranchGroupedAvailableInfoService_GetGroupedAvailableInfo<T>): FetchPromise<dto.BranchGroupedAvailableInfoListDTO> {
       return this.authorizedGet({
            pathParams: {
                "branchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{branchId}/GroupedAvailableInfo",
        });
    }
}

export interface BranchSettingsService_GetSetting<T> extends ServiceArgs<T> {
    branchId: number;
}

export interface BranchSettingsService_GetSetting1<T> extends ServiceArgs<T> {
    branchId: number;
    branchSettingId: number;
}

export class BranchSettingsService extends FrontOfficeServiceBase {
    protected baseUrl: string = "api/v2/Branch/";

    /**
     * @return OK
     */
    public getSetting<T>(params: BranchSettingsService_GetSetting<T>): FetchPromise<dto.BranchSettingListDTO> {
       return this.authorizedGet({
            pathParams: {
                "branchId": params.branchId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{branchId}/Setting",
        });
    }

    /**
     * @return OK
     */
    public getSetting1<T>(params: BranchSettingsService_GetSetting1<T>): FetchPromise<dto.BranchSettingDetailDTO> {
       return this.authorizedGet({
            pathParams: {
                "branchId": params.branchId,
                "branchSettingId": params.branchSettingId,
            },
            getTimeZone: params?.getTimeZone,
            onAbort: params?.onAbort,
            timeoutSeconds: params?.timeoutSeconds,
            url: "{branchId}/Setting/{branchSettingId}",
        });
    }
}
